import React from "react";
import { AppBar, Toolbar, Box, Typography, IconButton, Avatar, Menu, MenuItem } from "@mui/material";

export default function AdminDashboardAppBar({ user, onProfileClick, onLogout }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <AppBar position="sticky" elevation={6} sx={{ bgcolor: "#000000", color: "#fff" }}>
      <Toolbar sx={{ minHeight: 72, px: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Admin Dashboard
          {user?.firstName && (
            <span style={{ fontSize: '14px', marginLeft: '12px', opacity: 0.8 }}>
              Welcome, {user.firstName}!
            </span>
          )}
        </Typography>
        <Box display="flex" alignItems="center" gap={2}>
          <IconButton color="inherit" onClick={handleMenu}>
            <Avatar src={user?.avatar || user?.profilePicture} sx={{ width: 36, height: 36, mr: 1 }}>
              {user?.firstName?.[0]?.toUpperCase() || user?.name?.[0]?.toUpperCase() || 'A'}
            </Avatar>
          </IconButton>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
            <MenuItem onClick={() => { handleClose(); onProfileClick && onProfileClick(); }}>Profile</MenuItem>
            <MenuItem onClick={() => { handleClose(); onLogout && onLogout(); }}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
